var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecommit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1732",
    "data-name": "Rectangle 1732",
    width: 21.19,
    height: 18.841,
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stage_8:_Recommitment",
    "data-name": "Stage 8: Recommitment",
    transform: "translate(-592.108 -302.662)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_687",
    "data-name": "Ellipse 687",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(592.108 302.662)",
    fill: "#ee3d4b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_32065",
    "data-name": "Group 32065",
    transform: "translate(595.513 308.242)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32064",
    "data-name": "Group 32064",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13535",
    "data-name": "Path 13535",
    d: "M10.264,7.261a.37.37,0,1,1,.74,0v.5a1.872,1.872,0,0,1,1.573,1.8.37.37,0,0,1-.74,0,1.209,1.209,0,0,0-2.407,0,1.166,1.166,0,0,0,.377.8,1.146,1.146,0,0,0,.827.3A1.894,1.894,0,0,1,12.578,12.5a1.872,1.872,0,0,1-1.573,1.8v.6a.37.37,0,0,1-.74,0v-.6a1.872,1.872,0,0,1-1.573-1.8.369.369,0,1,1,.738,0,1.159,1.159,0,0,0,1.2,1.1,1.1,1.1,0,0,0,0-2.2,1.9,1.9,0,0,1-1.941-1.83,1.872,1.872,0,0,1,1.573-1.8Zm.982,11.389a.88.88,0,0,1-1.081.011C9.784,18.373.818,11.514.032,5.627A4.976,4.976,0,0,1,3.648.27C4.633.01,8-.411,10,5.034a.883.883,0,0,1-1.658.608C7.325,2.872,5.778,1.534,4.1,1.977a3.245,3.245,0,0,0-2.32,3.384c.591,4.423,6.985,9.9,8.909,11.457,1.888-1.592,8.136-7.162,8.726-11.57a3.252,3.252,0,0,0-2.317-3.414c-1.387-.366-2.686.486-3.669,2.356l.708.333a.2.2,0,0,1,.03.35L11.489,6.738a.2.2,0,0,1-.28-.043.2.2,0,0,1-.038-.106L10.9,3.343a.2.2,0,0,1,.288-.2l.638.3C13.833-.465,16.653-.1,17.542.131a4.985,4.985,0,0,1,3.614,5.382c-.782,5.852-9.539,12.842-9.911,13.136",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommit);
export default __webpack_public_path__ + "static/media/recommit.45b2414e7a06047a6eeb417f61ec2836.svg";
export { ForwardRef as ReactComponent };